import { useMemo } from "react";
import { WorkflowTemplate } from "@idw-types/data/reference-data/generic";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { mapEntitiesWithNameAndIdToSelectOptions } from "@utils/select-option-mapping-util";
import { resources } from "@constants/hardcoded-strings";

type WorkflowTemplateSelectFormGroupProps = BaseSelectFormGroupProps & {
    workflowTemplates: Array<WorkflowTemplate>
};

export const WorkflowTemplateSelectFormGroup = (props: WorkflowTemplateSelectFormGroupProps) => {
    const {
        workflowTemplates,
        onChange,
        selectedOption,
        idPrefix,
        disabled,
        isRequired,
        isSearchable,
        isClearable,
        isLoading,
        labelWidth
    } = props;

    const workflowTemplateOptions = useMemo(() => {
        return mapEntitiesWithNameAndIdToSelectOptions(workflowTemplates);
    }, [workflowTemplates]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-workflow-template-select`}
            label={resources.common.inputs.workflowTemplate.label}
            ariaLabel={resources.common.inputs.workflowTemplate.label}
            automationId={`${idPrefix}-workflow-template-select`}
            onChange={onChange}
            options={workflowTemplateOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isLoading={isLoading}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};